export const ERROR_MESSAGES = {
  EMAIL_TAKEN: 'Email already taken',
  EMAIL_CONFIRMATION_NOT_SENT: 'Confirmation email was not sent. Please, try again later',
  EMAIL_VERIFICATION_FAILED: 'Email verification failed',
  EMAIL_NOT_VERIFIED: 'Please verify email',
  INCORRECT_LOGIN_PAIR: 'Incorrect email or password',
  NOT_FOUND_BY_EMAIL: 'No users found with this email',
  PASSWORD_RESET_FAILED: 'Password reset failed',
  SERVER_ERROR: 'Please, try again later',
};
